import {Component, Input, OnInit} from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'xlog-footer',
    templateUrl: './footer.component.pug',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
    @Input() email: string;
    moment: any;

    constructor() {
    }

    ngOnInit() {
        this.moment = moment;
    }

}
